import { Signaling } from './signaling';

const StreamAudio = async ({localStream,rtcPeer,socket}) => {
  if (!socket || !localStream) {throw new Error('StreamAudio missing socket or localStream');}
  await Signaling(localStream,rtcPeer);
  return rtcPeer;
};

export default StreamAudio;